import { IntegrationFieldBuilder } from './integration-field-builder'
import { BaseIntegrationFieldConfig } from '../integration-form-types/integration-field-config'
import { IntegrationFormField } from '../integration-form-types/integration-form-field'
import { SupportedFormFields } from '../integration-form-types/supported-form-field-types'

interface IntegrationNameField extends IntegrationFormField {
  config: BaseIntegrationFieldConfig
}

export class IntegrationNameBuilder extends IntegrationFieldBuilder {
  field: SupportedFormFields = 'integration_name'

  config: BaseIntegrationFieldConfig = {
    placement: 0,
  }

  placement(placement: number): this {
    this.config.placement = placement
    return this
  }

  isHidden(hidden: boolean | undefined): this {
    this.config.isHidden = hidden
    return this
  }

  build(): IntegrationNameField {
    const integrationNameField: IntegrationNameField = {
      field: this.field,
      config: this.config,
    }

    if (!this.verifyBuiltField(integrationNameField)) {
      console.error('Error in the config sent to Integration Name Builder.')
    }

    return integrationNameField
  }

  verifyBuiltField(field: IntegrationNameField): boolean {
    if (field.field !== 'integration_name') {
      return false
    }

    return true
  }
}
